import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IResultItem } from '../../../interfaces/i-result-item';
import { SearchRequestBody } from '../../../models/search-request-body';
import { ISearchResponse } from '../../../interfaces/i-api-responses';
import { API_URL } from '../../../constants/api.constant';
import { ApiService } from '../../../services/api.service';
import {createEnsembleUrl, decodeBase64ToString} from "../../../utilities/formating";
import { DataCardType } from '../../../enums/api.enum';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  latestSearchResults = signal<IResultItem[]>([]);

  #http = inject(HttpClient);
  #apiService = inject(ApiService);

  fetchSearchResults(requestBody: SearchRequestBody) {
    const url = `${this.#apiService.apiBaseUrl}`;

    return this.#http.post<ISearchResponse>(url, requestBody);
  }

  fetchFeedResults(requestBody: {userId: number}) {
    const url = `${API_URL}/newsFeed`;

    return this.#http.post<ISearchResponse>(url, requestBody);
  }

  /**
   * Updates search results to be presentable in the UI.
   * The results have HTML elements <mark>.  This method removes them for the chips.
   */
  manageSearchResults(results: ISearchResponse): IResultItem[] {
    return results.value.map((item: any) => {
      let keyPhrases = [];
      if (item.keyphrases) {
        if (Array.isArray(item.keyphrases)) {
          keyPhrases = item.keyphrases;
        } else {
          keyPhrases = JSON.parse(item.keyphrases);
        }
      }
      const result: IResultItem = {
        score: item['@search.score'],
        dataCard: item.datacard,
        id: item.id,
        highlights: {
          unifiedContent: item['@search.highlights'].unifiedContent
        },
        unifiedContent: item.unifiedContent,
        mediaType: item.mediaType,
        ingestType: item.ingestType,
        metadataStoragePath: item.metadata_storage_path,
        metadataContentType: item.metadata_content_type,
        metadataStorageName: item.metadata_storage_name,
        lastUpdateDate: item.lastupdatedate,
        keyphrases: keyPhrases,
        webUrl: item.webUrl,
        sensitivityLabel: item.sensitivityLabel
      };
// const mockDataGovWin = {
//   "links": {
//     "webHref": {
//       "href": "https://iq.govwin.com/neo/opportunity/view/245975"
//     },
//     "markedByUsers": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/markedByUsers"
//     },
//     "relatedDocuments": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/relatedDocuments"
//     },
//     "contacts": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/contacts"
//     },
//     "placesOfPerformance": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/placesOfPerformance"
//     },
//     "govEntity": {
//       "href": "https://services.govwin.com/neo-ws/govEntities/26676"
//     },
//     "fboNotices": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/fboNotices"
//     },
//     "sourcedFrom": [
//       {
//         "href": "https://services.govwin.com/neo-ws/opportunities/FBO3851019"
//       }
//     ],
//     "relatedArticles": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/relatedArticles"
//     },
//     "contractVehicles": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/contractVehicles"
//     },
//     "verticals": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/verticals"
//     },
//     "assessment": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/assessment"
//     },
//     "companies": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/companies"
//     },
//     "milestones": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/milestones"
//     },
//     "contracts": {
//       "href": "https://services.govwin.com/neo-ws/opportunities/OPP245975/contracts"
//     }
//   },
//   "awardDate": {
//     "deltekEstimate": "true",
//     "govtEstimate": "false",
//     "value": "2024-11-28T00:00:00.000"
//   },
//   "competitionTypes": [
//     {
//       "id": 47,
//       "title": "Undetermined"
//     }
//   ],
//   "contractTypes": [
//     {
//       "id": 23,
//       "title": "TBD"
//     }
//   ],
//   "country": "USA",
//   "createdDate": "2024-08-21T09:06:49.053",
//   "description": "<p>The United States Department of Agriculture (USDA), Agricultural Research Service (ARS) has a requirement for&nbsp;Digital Preservation Software Support for the National Agricultural Library (NAL), located in Beltsville, Maryland.</p>\n\n<h4>BACCKGROUND</h4>\n\n<p>The National Agricultural Library&rsquo;s (NAL) current technological infrastructure struggles to provide long-term preservation to match the rapid uptick in digital content creation, increased digitization efforts, and curation of complex research datasets. In addition to regular data back-ups, NAL should develop a long-term preservation strategy that addresses file and media formats, redundancy, software and hardware obsolescence, accessibility, migration, standards, security, authenticity, and integrity. Software and storage options suitable for the scale and nature of this activity should be deployed and the overall framework should be carefully planned, documented, and managed.</p>\n\n<h4>REQUIREMENTS</h4>\n\n<p>Project Scope:</p>\n\n<ul>\n\t<li>NAL requires a digital preservation system that will ensure that the library&rsquo;s digital collections and assets remain accessible in the long-term, supporting digital ways of working with staff and users, reducing, or eliminating potential risk of catastrophic data loss, and support key strategic priorities</li>\n\t<li>NAL requires a long-term active digital preservation and secure access (backup, archiving, storage and content management) in a single, intuitive and fully supported application aligned to the OAIS ISO 14721 standard. The system will Safely store content, ensuring that it can be found and trusted, provide secure immediate access, and automatically update files to future-friendly formats</li>\n\t<li>Archivematica currently meets the standards-based preservation needs and in-house as opposed to SaaS. Artefactual is the developer of the code base and the only company capable of providing support and patching of their software. The system must also provide configuration and development support, risk mitigation support, custom code, and patching of Archivematica in a timely fashion to meet USDA/Federal cybersecurity needs</li>\n</ul>\n",
//   "duration": "1 year(s) base plus 4 x 1 year(s) option(s) ",
//   "govEntity": {
//     "id": 26676,
//     "title": "AGRICULTURAL RESEARCH SERVICE"
//   },
//   "id": "OPP245975",
//   "iqOppId": 245975,
//   "oppValue": 0,
//   "primaryNAICS": {
//     "id": "513210",
//     "title": "Software Publishers",
//     "sizeStandard": "$47.0 million annual receipts"
//   },
//   "primaryRequirement": "Software",
//   "procurement": "<p>The Contracting Office released a Sources Sought on August 20, 2024. Responses are due no later than 4:30 PM EDT on August 22, 2024. Angela B. Wingert is the primary Point of Contact.</p>\n",
//   "smartTag": "Products & Services > Primary Tags:Software maintenance, Secondary Tags:Software as a service, ",
//   "smartTagObject": [
//     {
//       "id": "5EF6355E-ACDD-5601-B67E-9C668A8ADF30",
//       "name": "Software maintenance",
//       "type": "Services",
//       "isPrimary": 1
//     },
//     {
//       "id": "5A032E41-EF43-487A-9B6E-D933B1C695CF",
//       "name": "Software as a service",
//       "type": "Services",
//       "isPrimary": 0
//     }
//   ],
//   "solicitationDate": {
//     "deltekEstimate": "true",
//     "govtEstimate": "false",
//     "value": "2024-09-25T00:00:00.000"
//   },
//   "solicitationNumber": "1232SA24Q0151",
//   "sourceURL": "https://sam.gov/opp/cf36ef5f7ad8405b8ce1c80897885de9/view",
//   "status": "Pre-RFP",
//   "title": "DIGITAL PRESERVATION SOFTWARE SUPPORT",
//   "type": "trackedopp",
//   "typeOfAward": "Undetermined",
//   "updateDate": "2024-08-21T09:06:49.053"
// };

      // switch(item.datacard) {
      //   case DataCardType.Snf:
      //     result.content = item.content;
      //     break;
      //     case DataCardType.Govwin:
      //     result.content = mockDataGovWin;
      //     break;
      //   default:
      //     result.content = item.content;
      // }

      return result;
    });

    // return results.value.map((item) => {
      
    // // console.log(decodeBase64ToString(item.metadata_storage_path));
    //   const result: IResultItem = {
    //     score: item['@search.score'],
    //     classification: 'TBD', // item.sensitivity
    //     content: item.content,
    //     metadataStoragePath: createEnsembleUrl(item.metadata_storage_path),
    //     metadataStorageName: item.metadata_storage_name,
    //     metadataStorageFileExtension: item.metadata_storage_file_extension.substring(1),  // API returns '.[file ext]'. Remove '.'
    //     people: item.people,
    //     organizations: item.organizations,
    //     keyPhrases: item.keyphrases,
    //     highlights: {}
    //   };

    //   if (Object.hasOwn(item, '@search.highlights')) {
    //     if (item['@search.highlights'].content && item['@search.highlights'].content.length > 0) {
    //       result.highlights!.content = item['@search.highlights'].content;
    //     }

    //     if (item['@search.highlights'].people && item['@search.highlights'].people.length > 0) {
    //       result.highlights!.people = item['@search.highlights'].people;
    //     }

    //     if (item['@search.highlights'].keyphrases && item['@search.highlights'].keyphrases.length > 0) {
    //       result.highlights!.keyPhrases = item['@search.highlights'].keyphrases;
    //     }

    //     if (item['@search.highlights'].organizations && item['@search.highlights'].organizations.length > 0) {
    //       result.highlights!.organizations = item['@search.highlights'].organizations;
    //     }
    //   }

    //   return result;
    // });
  }
}
